import { Action, createReducer, on } from '@ngrx/store';
import * as uscActions from './user-supporting-company.actions';
import { UserSupportingCompanyState, initialState } from './user-supporting-company.state';
import { UserSupportingCompany } from '@interfaces';

const updateUserSupportingCompanyCollection = (
  existingCollection: UserSupportingCompany[] | null,
  updatedItem: UserSupportingCompany
): UserSupportingCompany[] | null => {
  if (existingCollection === null || !Array.isArray(existingCollection)) {
    return existingCollection;
  }

  // SHOULD NOT EXIST IN THE COLLECTION
  if (updatedItem.canViewProcesses === false) {
    return existingCollection.filter(
      // If companyId === updatedItem.companyId && userId === updatedItem.userId
      // then we're sure this is the row to be removed (only 1 such row exists because of unique index in DB: companyId + userId)
      // thus filter function must return false (we don't want this item in our output array)
      ({ companyId, userId }) => !(companyId === updatedItem.companyId && userId === updatedItem.userId)
    );
  }

  // NOT EXISTS IN CURRENT COLLECTION AND SHOULD BE ADDED
  const itemInCollectionIndex = existingCollection.findIndex(
    ({ companyId, userId }) => companyId === updatedItem.companyId && userId === updatedItem.userId
  );
  if (itemInCollectionIndex === -1) {
    return [{ ...updatedItem }, ...existingCollection];
  }

  // EXISTS IN CURRENT COLLECTION but must be updated
  return existingCollection.map(existingItem => {
    if (existingItem.userId === updatedItem.userId && existingItem.companyId === updatedItem.companyId) {
      return { ...updatedItem };
    }
    return { ...existingItem };
  });
};

const reducer = createReducer(
  initialState,
  on(uscActions.getCompaniesSupportedByUser, state => ({
    ...state,
    loadingCompaniesSupportedByUser: true,
  })),
  on(uscActions.getCompaniesSupportedByUserSuccess, (state, { companiesSupportedByUser }) => ({
    ...state,
    loadingCompaniesSupportedByUser: false,
    companiesSupportedByUser,
    errorMessage: null,
  })),
  on(uscActions.getCompaniesSupportedByUserError, (state, { errorMessage }) => ({
    ...state,
    loadingCompaniesSupportedByUser: false,
    errorMessage,
  })),

  on(uscActions.getUsersSupportingCompany, state => ({
    ...state,
    loadingUsersSupportingCompany: true,
  })),
  on(uscActions.getUsersSupportingCompanySuccess, (state, { usersSupportingCompany }) => ({
    ...state,
    loadingUsersSupportingCompany: false,
    usersSupportingCompany,
    errorMessage: null,
  })),
  on(uscActions.getUsersSupportingCompanyError, (state, { errorMessage }) => ({
    ...state,
    loadingUsersSupportingCompany: false,
    errorMessage,
  })),

  on(uscActions.updateSupportingCompanyOfUser, state => ({
    ...state,
    updateInProgress: true,
  })),
  on(uscActions.updateSupportingCompanyOfUserSuccess, (state, { userSupportingCompany }) => {
    return {
      ...state,
      companiesSupportedByUser: updateUserSupportingCompanyCollection(
        state.companiesSupportedByUser,
        userSupportingCompany
      ),
      usersSupportingCompany: updateUserSupportingCompanyCollection(
        state.usersSupportingCompany,
        userSupportingCompany
      ),
      updateInProgress: false,
    };
  }),
  on(uscActions.updateSupportingCompanyOfUserError, (state, { errorMessage }) => ({
    ...state,
    updateInProgress: false,
    errorMessage,
  }))
);

export function userSupportingCompanyReducer(
  state: UserSupportingCompanyState | undefined,
  action: Action
): UserSupportingCompanyState {
  return reducer(state, action);
}
